import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import updateState from '../../actions/updateState';
import updateAnalytics from '../../actions/updateAnalytics';
import convertNumber from '../../actions/convertNumber';
import translate from '../../actions/translate';

export default function AlertDialog() {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const placedTestOrder = useSelector(
    (state) => state.formState.Did_place_test_order
  );
  const ownerPhone = useSelector((state) => state.formState.Owner_phone);
  const restaurantId = useSelector((state) => state.formState.Restaurant_id);
  const ownerName = useSelector((state) => state.formState.Owner_name);
  const alternatePhone = useSelector(
    (state) => state.formState.Alternate_number
  );
  const baseURL = useSelector((state) => state.formState.baseURL);

  useEffect(() => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const peopleInfo = {
      method: 'push',
      resource: 'restaurant',
      query: {
        _id: restaurantId,
        disabled: true,
      },
      payload: {
        people: {
          name: ownerName,
          roles: ['Owner'],
          channels: [{ type: 'SMS', value: convertNumber(ownerPhone) }],
        },
      },
    };

    axios
      .post(`${baseURL}/smart-restaurant/api`, peopleInfo, config)
      .catch((e) => console.log('PEOPLE INFO FAILED ', e));
  }, [ownerName, ownerPhone, restaurantId]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOrder = async () => {
    dispatch(updateState({ Did_place_test_order: true }));
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const checkDuplicatesAndProcessInfo = async () => {
      // Create the existing body
      let existingBody = '';
      let duplicate = false;
      if (alternatePhone.length === 17) {
        console.log('ANALYTIC ALTERNATE FIRED');
        existingBody = {
          method: 'get',
          resource: 'restaurant',
          query: {
            _id: restaurantId,
            disabled: true,
            'channels.value': convertNumber(alternatePhone),
          },
          payload: {
            channels: 1,
          },
        };
      } else {
        existingBody = {
          method: 'get',
          resource: 'restaurant',
          query: {
            _id: restaurantId,
            disabled: true,
            'channels.value': convertNumber(ownerPhone),
          },
          payload: {
            channels: 1,
          },
        };
      }

      // check the existing body

      try {
        const existingRes = await axios.post(
          `${baseURL}/smart-restaurant/api`,
          existingBody,
          config
        );
        if (
          // eslint-disable-next-line operator-linebreak
          existingRes.data &&
          // eslint-disable-next-line operator-linebreak
          existingRes.data[0] &&
          existingRes.data[0].channels
        ) {
          duplicate = true;
        } else {
          duplicate = false;
        }
      } catch (e) {
        console.log('Couldnt test for duplicates', e);
      }

      // if duplicate, make submit order call with existing body. Else post the new body first
      const submitOrderBody = {
        restaurantId,
      };

      if (!duplicate) {
        // check if alternate number
        let channelBody = '';
        let channelBody2 = '';

        if (alternatePhone.length === 17) {
          channelBody = {
            method: 'push',
            resource: 'restaurant',
            query: {
              _id: restaurantId,
              disabled: true,
            },
            payload: {
              channels: {
                type: 'SMS',
                value: convertNumber(alternatePhone),
                notifications: ['Order'],
              },
            },
          };
          channelBody2 = {
            method: 'push',
            resource: 'restaurant',
            query: {
              _id: restaurantId,
              disabled: true, // to avoid duplicates
            },
            payload: {
              channels: {
                type: 'Phone',
                value: convertNumber(alternatePhone),
                notifications: ['Order'],
              },
            },
          };

          try {
            await axios.post(
              `${baseURL}/smart-restaurant/api`,
              channelBody2,
              config
            );
            await axios.post(
              `${baseURL}/smart-restaurant/api`,
              channelBody,
              config
            );
          } catch (e) {
            console.log('CHANNEL ERROR', e);
          }
        } else {
          channelBody = {
            method: 'push',
            resource: 'restaurant',
            query: {
              _id: restaurantId,
              disabled: true,
            },
            payload: {
              channels: {
                type: 'SMS',
                value: convertNumber(ownerPhone),
                notifications: ['Order'],
              },
            },
          };
          channelBody2 = {
            method: 'push',
            resource: 'restaurant',
            query: {
              _id: restaurantId,
              disabled: true, // to avoid duplicates
            },
            payload: {
              channels: {
                type: 'Phone',
                value: convertNumber(ownerPhone),
                notifications: ['Order'],
              },
            },
          };

          try {
            await axios.post(
              `${baseURL}/smart-restaurant/api`,
              channelBody2,
              config
            );
            await axios.post(
              `${baseURL}/smart-restaurant/api`,
              channelBody,
              config
            );
          } catch (e) {
            console.log('CHANNEL ERROR', e);
          }
        }

        try {
          await axios.post(
            `${baseURL}/utils/submit-order`,
            submitOrderBody,
            config
          );
          updateAnalytics({ placedOrder: true }, restaurantId);
        } catch (e) {
          console.log('ORDER FAILED ', e);
        }
      } else {
        // just submit the order already

        try {
          await axios.post(
            `${baseURL}/utils/submit-order`,
            submitOrderBody,
            config
          );
          updateAnalytics({ placedOrder: true }, restaurantId);
        } catch (e) {
          console.log('SUBMIT ERROR', e);
        }
      }
    };

    await checkDuplicatesAndProcessInfo();
  };

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        disabled={placedTestOrder}
        onClick={() => {
          handleOrder();
          handleClickOpen();
        }}
      >
        {translate('Place Test Order')}
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {translate('QMENU TEST ORDER')}
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {translate(
              'You will be notified via an SMS and call regarding this new simulated order'
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            {translate('Exit')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
